// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';

export const Unlock = ({ size, stroke, fill }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 48 48'
      width={size}
      height={size}
      fill='none'
      stroke={stroke}
      strokeWidth='2px'
    >
      <rect fill={fill} x='8.7' y='24.1' width='30.6' height='22.9' rx='3.1' ry='3.1' />
      <path d='M12.6,12.1C12.6,5.8,17.7.7,24,.7s6,1.3,8.1,3.4c2.1,2.1,3.3,4.9,3.3,8.1v12' />
      <path d='M26,32.6c0,.8-.5,1.5-1.2,1.9v5.7h-1.8v-5.7c-.7-.3-1.2-1-1.2-1.9s.9-2,2-2,2,.9,2.1,2.1Z' />
    </svg>
  );
};
